export default __webpack_public_path__ + "static/NotoSansTifinagh-Regular-43fe5554c4bae4823de844453f5468fb.woff";